import { Pipe, PipeTransform } from '@angular/core'
import { ScaleBand, ScaleLinear, ScaleTime } from 'd3'
import { Venue } from '@app/domain/Venue'

@Pipe({
    name: 'scale',
})
export class ScalePipe implements PipeTransform {

    transform(
        domainValue: any | null,
        scale: ScaleTime<any, any> | ScaleBand<any> | ScaleLinear<any, any>,
        relativeToEndDomainValue?: any,
        minimumValue?: number,
        maximumValue?: number
    ): number {
        let value
        if (domainValue === null) {
            value = scale.range()[1]
        } else {
            const start = scale(domainValue)
            if (relativeToEndDomainValue) {
                const end = scale(relativeToEndDomainValue)
                value = Math.max(0, end - start)
            } else {
                value = start
            }
        }
        if (minimumValue !== undefined && value < minimumValue) {
            value = minimumValue
        }
        if (maximumValue !== undefined && value > maximumValue) {
            value = maximumValue
        }
        return value
    }
}

export function getNiceMinutesPerTick(venue: Venue, scale: ScaleTime<number, number>) {
    const interval = venue.bookingInterval
    if (!interval) {
        return 60
    }
    const totalTime = scale.domain()[1].getTime() - scale.domain()[0].getTime()
    const totalMinutes = totalTime / 1000 / 60
    const totalIntervals = totalMinutes / interval
    const widthPerInterval = scale.range()[1] / totalIntervals
    let stepMinutes = 0
    const step = widthPerInterval < 22 ? 2 : 1
    stepMinutes = interval * step
    const tooSmallToShowAnyIntervals = widthPerInterval < 12
    if (tooSmallToShowAnyIntervals) {
        stepMinutes = 60
    }
    return stepMinutes
}
